export default __webpack_public_path__ + "static/media/rightLayer.a466ea10.png";